import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { ToastGuidGroup } from '../types/toastGuidGroup';
import { toastGuidGroupQueryKeys } from './useToastGuidGroups';

type DefaultError = unknown;

type UseToastGuidGroupParams = {
  id: string;
  include?: string;
  enabled?: boolean;
};

export function useToastGuidGroup<TData = ToastGuidGroup, TError = DefaultError>(
  { id, include, enabled = true }: UseToastGuidGroupParams,
  options?: Omit<
    UseQueryOptions<ToastGuidGroup, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = toastGuidGroupQueryKeys.detail(id);
  const fullQueryKey = include ? [...queryKey, include] : queryKey;

  return useQuery<ToastGuidGroup, TError, TData>({
    queryKey: fullQueryKey,
    enabled: enabled && !!id,
    queryFn: async () => service.getToastGuidGroup(id, { include }),
    ...(options as any),
  });
}
